import { createApp } from 'vue'
import App from './App.vue'
const app = createApp(App);
import router from './router/index'

import { Tabbar, TabbarItem } from 'vant';
import { Button } from 'vant';
import { Search } from 'vant'
import { Tab, Tabs } from 'vant'
import { Image as VanImage } from 'vant'
import { Cell, CellGroup } from 'vant'
import { NavBar } from 'vant';
import { Grid, GridItem } from 'vant';
import { Icon } from 'vant';
import { IndexBar, IndexAnchor } from 'vant';
import { ActionSheet } from 'vant';
import { Tag } from 'vant';
import { Field } from 'vant';
import { Dialog } from 'vant';
import { Rate } from 'vant';
import { ActionBar, ActionBarIcon, ActionBarButton } from 'vant';
import { Uploader } from 'vant';
import { Card } from 'vant';
import { DropdownMenu, DropdownItem } from 'vant';
import { Area } from 'vant';
import { DatetimePicker } from 'vant';
import { Picker } from 'vant';
import { Swipe, SwipeItem } from 'vant';
import { Stepper } from 'vant';
import { Empty } from 'vant';
import { TreeSelect } from 'vant';
import { Sidebar,SidebarItem } from 'vant';

app.use(Sidebar);
app.use(SidebarItem);
app.use(TreeSelect);
app.use(Empty);
app.use(Stepper);
app.use(Swipe);
app.use(SwipeItem);
app.use(Picker);
app.use(DatetimePicker);
app.use(Area);
app.use(DropdownMenu);
app.use(DropdownItem);
app.use(Card);
app.use(Uploader);
app.use(ActionBar);
app.use(ActionBarIcon);
app.use(ActionBarButton);
app.use(Rate);
app.use(Dialog);
app.use(Field);
app.use(Tag);
app.use(ActionSheet);
app.use(IndexBar);
app.use(IndexAnchor);
app.use(Icon);
app.use(Grid);
app.use(GridItem);
app.use(NavBar);
app.use(Button);
app.use(Tabbar);
app.use(TabbarItem);
app.use(Search);
app.use(Tab);
app.use(Tabs);
app.use(VanImage);
app.use(Cell);
app.use(CellGroup);

app.use(router);
app.mount('#app');
